import { useQuery } from "@tanstack/react-query";
import { getCustomerContractSettings } from "controller/api";

export const useGetCustomerContractSettings = (customerId: string) => {
  return useQuery({
    queryKey: ["customer_contracts", customerId],
    queryFn: () => getCustomerContractSettings(customerId),
    onError: (error) => console.log(error),
    enabled: customerId ? true : false,
  });
};
